import { ShieldCheck } from 'lucide-react';
import { useState, type FormEvent } from 'react';
import { getApiErrorMessage } from '../api/client';
import { useAuth } from '../context/AuthContext';

export function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(getApiErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="login-card">
        <div className="login-brand">
          <ShieldCheck size={28} color="var(--onyx-gold)" aria-hidden />
          <span>Onyx Pay</span>
        </div>
        <h1 className="login-title">Master Admin Console</h1>
        <p className="login-sub">Internal access · CEO &amp; staff only</p>

        <form className="login-form" onSubmit={(e) => void onSubmit(e)}>
          <label className="login-label" htmlFor="email">
            Email
          </label>
          <input
            id="email"
            className="login-input"
            type="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label className="login-label" htmlFor="password">
            Password
          </label>
          <input
            id="password"
            className="login-input"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          {error ? <p className="login-error">{error}</p> : null}

          <button className="btn-primary login-submit" type="submit" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign In to Onyx Console'}
          </button>
        </form>
      </div>
    </div>
  );
}
